export const regxCsvIgnoreWrappedInDoubleQuotes = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/

export const secretKey = "";

export const dataProductsAccessRulesFileName = "data-products-access-rules.json";

export const customDataProductsAccessRulesFileName = "custom-data-products-access-rules.json";

export const dataAccessGroupsBulkTemplateEmptyFileName = "data-access-groups-bulk-template-empty.csv";

export const dataAccessGroupsBulkTemplateExistingFileName = "data-access-groups-bulk-template-existing.csv";